import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-15a9c0bf"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["srcset", "media"]
const _hoisted_2 = ["srcset"]
const _hoisted_3 = ["srcset", "media"]
const _hoisted_4 = ["src"]

import { computed } from 'vue';

interface Props {
  mobileImageWebp?: string;
  mobileImage?: string;
  image: string;
  imageWebp?: string;
  imageW?: number;
  imageH?: number;
  mobileImageW?: number;
  mobileImageH?: number;
}

export default /*#__PURE__*/_defineComponent({
  props: {
    mobileImageWebp: null,
    mobileImage: null,
    image: null,
    imageWebp: null,
    imageW: null,
    imageH: null,
    mobileImageW: null,
    mobileImageH: null
  },
  setup(__props: any) {

const props = __props as {
  mobileImageWebp?: string;
  mobileImage?: string;
  image: string;
  imageWebp?: string;
  imageW?: number;
  imageH?: number;
  mobileImageW?: number;
  mobileImageH?: number;
}



const paddingBottom = computed(() => {
  const { imageW, imageH } = props;
  if (imageW && imageH) {
    return `${imageH / imageW * 100}%`;
  }
  return '';
});

const paddingBottomMobile = computed(() => {
  const { mobileImageW, mobileImageH } = props;
  if (mobileImageW && mobileImageH) {
    return `${mobileImageH / mobileImageW * 100}%`;
  }
  return '';
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["responsive-image", { 'fixed-height': !!_unref(paddingBottom), 'fixed-height-mobile': !!_unref(paddingBottomMobile) }]),
    style: _normalizeStyle(`--padding-bottom: ${_unref(paddingBottom)}; --padding-bottom-mobile: ${_unref(paddingBottomMobile)};`)
  }, [
    _createElementVNode("picture", null, [
      (__props.mobileImageWebp)
        ? (_openBlock(), _createElementBlock("source", {
            key: 0,
            srcset: __props.mobileImageWebp,
            media: `(max-width: ${768}px)`,
            type: "image/webp"
          }, null, 8, _hoisted_1))
        : _createCommentVNode("", true),
      (__props.imageWebp)
        ? (_openBlock(), _createElementBlock("source", {
            key: 1,
            srcset: __props.imageWebp,
            type: "image/webp"
          }, null, 8, _hoisted_2))
        : _createCommentVNode("", true),
      (__props.mobileImage)
        ? (_openBlock(), _createElementBlock("source", {
            key: 2,
            srcset: __props.mobileImage,
            media: `(max-width: ${768}px)`
          }, null, 8, _hoisted_3))
        : _createCommentVNode("", true),
      _createElementVNode("img", {
        src: __props.image,
        alt: "image",
        loading: "lazy"
      }, null, 8, _hoisted_4)
    ])
  ], 6))
}
}

})